import AutoFormAutoComplete from './AutoFormAutoComplete.vue'
import AutoFormFieldArray from './AutoFormFieldArray.vue'
import AutoFormFieldBoolean from './AutoFormFieldBoolean.vue'
import AutoFormFieldDate from './AutoFormFieldDate.vue'
import AutoFormFieldEnum from './AutoFormFieldEnum.vue'
import AutoFormFieldFile from './AutoFormFieldFile.vue'
import AutoFormFieldInput from './AutoFormFieldInput.vue'
import AutoFormFieldNumber from './AutoFormFieldNumber.vue'
import AutoFormFieldObject from './AutoFormFieldObject.vue'
import AutoFormMultiBox from './AutoFormMultiBox.vue'
import AutoFormMultiSelect from './AutoFormMultiSelect.vue'
import AutoFormSelectIcon from './AutoFormSelectIcon.vue'
import AutoFormTimer from './AutoFormTimer.vue'
import type { InputComponents } from './interface'

export const INPUT_COMPONENTS: InputComponents = {
  date: AutoFormFieldDate,
  select: AutoFormFieldEnum,
  radio: AutoFormFieldEnum,
  checkbox: AutoFormFieldBoolean,
  switch: AutoFormFieldBoolean,
  textarea: AutoFormFieldInput,
  ticketDescription: AutoFormFieldInput,
  number: AutoFormFieldNumber,
  string: AutoFormFieldInput,
  file: AutoFormFieldFile,
  autocomplete: AutoFormAutoComplete,
  multibox: AutoFormMultiBox,
  multiselect: AutoFormMultiSelect,
  icon: AutoFormSelectIcon,
  array: AutoFormFieldArray,
  object: AutoFormFieldObject,
  timer: AutoFormTimer,
}

/**
 * Define handlers for specific Zod types.
 * You can expand this object to support more types.
 */
export const DEFAULT_ZOD_HANDLERS: {
  [key: string]: keyof typeof INPUT_COMPONENTS
} = {
  ZodString: 'string',
  ZodBoolean: 'checkbox',
  ZodDate: 'date',
  ZodEnum: 'select',
  ZodNativeEnum: 'select',
  ZodNumber: 'number',
  ZodArray: 'array',
  ZodObject: 'object',
}
